import { ExclamationCircleFilled } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Col } from 'antd';
import { Account } from 'src/models';
import { ColorConstant } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import { AccountHolderFullName } from './AccountHolderFullName';
import { MenuItem } from './MenuItem';

const baseStyle = (lastFailedLinkAccountError?: string) =>
  css({
    background: lastFailedLinkAccountError ? ColorConstant.ORANGE1 : undefined,
  });

interface AccountMenuItemProps {
  account?: Account;
  isLoading?: boolean;
  onClick: () => void;
}

export const AccountMenuItem = ({ account, isLoading, onClick }: AccountMenuItemProps) => {
  return (
    <MenuItem
      name={
        <>
          <AccountHolderFullName account={account} alignment={'start'} />
          <Col>
            {account?.lastFailedLinkAttemptError && (
              <MTypography variant='body1' color={ColorConstant.ORANGE6}>
                Linking Error
              </MTypography>
            )}
          </Col>
        </>
      }
      startIcon={<i className='ri-user-line' style={{ fontSize: 24 }} />}
      endIcon={
        account?.lastFailedLinkAttemptError ? (
          <ExclamationCircleFilled style={{ fontSize: '24px', color: ColorConstant.ORANGE6 }} />
        ) : undefined
      }
      isLoading={isLoading}
      onClick={isLoading ? undefined : onClick}
      className={baseStyle(account?.lastFailedLinkAttemptAt)}
    />
  );
};
